import apiClient from '@/utils/apiClient';

const CUSTOM_OFFER = '/api/custom-offers';
const GET_CUSTOM_OFFER = `${CUSTOM_OFFER}/verify`;
const CREATE_CHECKOUT_SESSION = `${CUSTOM_OFFER}/create-checkout-session`;

export const verifyCustomOffer = async (
	encodedData: string,
): Promise<{
	success: boolean;
	message: string;
	data?: {
		interval: string;
		intervalCount: number;
		productName: string;
		trialDays: number;
		type: string;
		quantity: number;
		price: string;
		features?: object;
	};
}> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: GET_CUSTOM_OFFER,
		body: { encodedData },
	});
	return response;
};

export const createCheckoutSession = async ({
	encodedData,
	userData,
}: {
	encodedData: string;
	userData: object;
}): Promise<{ success: boolean; checkoutURL: string; token?: string }> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: CREATE_CHECKOUT_SESSION,
		body: { encodedData, ...userData },
	});
	return response;
};
